import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { InfogeoModel } from './models/infogeo.model';

@Injectable({
  providedIn: 'root'
})
export class MapsService {

  constructor(private http: HttpClient) { }

  // https://reverse.geocoder.ls.hereapi.com/6.2/reversegeocode.json?prox=41.8842%2C-87.6388%2C250&mode=retrieveAddresses&maxresults=1&gen=9&apiKey=H6XyiCT0w1t9GgTjqhRXxDMrVj9h78ya3NuxlwM7XUs
  async getInfogeoFromPoint(lat: number, lng: number, radius: number, maxResult: number): Promise<InfogeoModel> {
    try {
      const httpOptions = {
        headers: null,
        withCredentials: false
      };
      const result: any = await this.http.get('https://reverse.geocoder.ls.hereapi.com/6.2/reversegeocode.json?prox=' +
        lat + '%2C' + lng + '%2C' + radius + '&mode=retrieveAddresses&maxresults=' +
        maxResult + '&gen=9&apiKey=' + environment.hereApiKeyRest, httpOptions).toPromise();
      if (result.Response !== undefined && result.Response.View !== undefined && result.Response.View.length > 0 &&
        result.Response.View[0].Result !== undefined && result.Response.View[0].Result.length > 0 &&
        result.Response.View[0].Result[0].Location !== undefined && result.Response.View[0].Result[0].Location.Address !== undefined) {
        return JSON.parse(JSON.stringify(result.Response.View[0].Result[0].Location.Address));
      }
    } catch (e) {
      console.log("InfoGeo: " + e);
    }
    return null;
  }
}
